import { ActionIcon, Box, Button, Checkbox, Group, Stack, Text, TextInput } from '@mantine/core';
import { randomId } from '@mantine/hooks';
import { IconPlus, IconTrash } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { useAmlFormContext } from '../types/types';

export function RelatedPersonsStep() {
  const { t } = useTranslation();
  const form = useAmlFormContext();

  return (
    <Stack gap="md" mt="md">
      <Stack gap="xs">
        <Text size="sm" fw={500}>
          {t(i18nKeys.AML_MODAL.RELATED_PERSONS.DIRECTORS)}
        </Text>
        <Text size="xs" c="dimmed">
          {t(i18nKeys.AML_MODAL.RELATED_PERSONS.DIRECTORS_HINT)}
        </Text>
        {form.values.directors.map((director, index) => (
          <Stack key={director.key} gap="xs">
            <Group gap="xs" align="flex-end">
              <TextInput
                required
                style={{ flex: 1 }}
                placeholder={t(i18nKeys.AML_MODAL.RELATED_PERSONS.PLACEHOLDERS.DIRECTOR_NAME)}
                {...form.getInputProps(`directors.${index}.name`)}
              />
              {form.values.directors.length > 1 && (
                <ActionIcon
                  variant="subtle"
                  color="red"
                  onClick={() => form.removeListItem('directors', index)}
                >
                  <IconTrash size={16} />
                </ActionIcon>
              )}
            </Group>
            <Checkbox
              label={t(i18nKeys.AML_MODAL.RELATED_PERSONS.CAN_BIND)}
              {...form.getInputProps(`directors.${index}.canBind`, { type: 'checkbox' })}
            />
          </Stack>
        ))}
        <Button
          variant="subtle"
          size="xs"
          leftSection={<IconPlus size={14} />}
          onClick={() =>
            form.insertListItem('directors', { key: randomId(), name: '', canBind: false })
          }
          disabled={!form.values.directors.at(-1)?.name.trim()}
          style={{ alignSelf: 'flex-start' }}
        >
          {t(i18nKeys.AML_MODAL.RELATED_PERSONS.ADD_DIRECTOR)}
        </Button>
      </Stack>

      <Box p="sm" style={{ border: '1px solid var(--mantine-color-gray-3)', borderRadius: 6 }}>
        <Checkbox
          label={t(i18nKeys.AML_MODAL.RELATED_PERSONS.LISTED_COMPANY)}
          {...form.getInputProps('listedCompany', { type: 'checkbox' })}
        />
      </Box>

      {!form.values.listedCompany && (
        <Stack gap="xs">
          <Text size="sm" fw={500}>
            {t(i18nKeys.AML_MODAL.RELATED_PERSONS.BENEFICIAL_OWNERS)}
          </Text>
          {form.values.beneficialOwners.map((owner, index) => (
            <Group key={owner.key} gap="xs" align="flex-end">
              <TextInput
                required
                style={{ flex: 1 }}
                placeholder={t(
                  i18nKeys.AML_MODAL.RELATED_PERSONS.PLACEHOLDERS.BENEFICIAL_OWNER_NAME,
                )}
                {...form.getInputProps(`beneficialOwners.${index}.name`)}
              />
              {form.values.beneficialOwners.length > 1 && (
                <ActionIcon
                  variant="subtle"
                  color="red"
                  onClick={() => form.removeListItem('beneficialOwners', index)}
                >
                  <IconTrash size={16} />
                </ActionIcon>
              )}
            </Group>
          ))}
          <Button
            variant="subtle"
            size="xs"
            leftSection={<IconPlus size={14} />}
            onClick={() => form.insertListItem('beneficialOwners', { key: randomId(), name: '' })}
            disabled={!form.values.beneficialOwners.at(-1)?.name.trim()}
            style={{ alignSelf: 'flex-start' }}
          >
            {t(i18nKeys.AML_MODAL.RELATED_PERSONS.ADD_BENEFICIAL_OWNER)}
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
